import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import authService from "../services/authService";
import AppLayout from "../components/AppLayout";
import Footer from "../components/Footer";
import "./Auth.css";

function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      setMessage("⚠️ Informe seu e-mail cadastrado.");
      return;
    }

    try {
      const response = await authService.forgotPassword({ email });
      setMessage(response.data.message || "✅ Verifique seu e-mail para redefinir a senha.");
    } catch (error) {
      setMessage(error.response?.data?.error || "❌ Erro ao solicitar redefinição de senha.");
    }
  };

  return (
    <AppLayout>
      <div className="auth-container">
        <h2>🔑 Recuperar Senha</h2>
        <form onSubmit={handleSubmit} className="auth-form">
          <input
            type="email"
            name="email"
            placeholder="Digite seu e-mail cadastrado"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <button type="submit" className="auth-button">Enviar Link de Recuperação</button>
        </form>
        {message && <p className="auth-message">{message}</p>}

        <button
          type="button"
          className="recover-button"
          onClick={() => navigate("/login")}
        >
          Voltar para Login
        </button>
      </div>
      <Footer />
    </AppLayout>
  );
}

export default ForgotPassword;
